import { useQuery } from "@tanstack/react-query";
import { apiClient, ApiResponse } from "@/core/api/axios-client";
import { MenuItem, MenuResponse } from "@/core/api/types/menu";
import { TokenStorage } from "@/core/api/storage";

const MENU_QUERY_KEY = "menu";

/**
 * Sezione "Demo" - Voci di menu hardcoded per pagine in sviluppo
 * Queste pagine NON sono ancora collegate all'API e usano dati mock/stubbed
 * Tutte le route hanno prefisso "demo/"
 */
export const DESIGN_MENU_ITEMS: MenuItem[] = [
  {
    id_menu: "demo_didattica",
    id_father_menu: "0",
    module_name: "didattica",
    item_name: "didattica",
    sort_order: "1",
    item_label: "Didattica",
    left_icon: "ri-book-open-line",
    route: null,
    enabled: "1",
    in_test: "1",
    childs: [
      {
        id_menu: "demo_didattica_corsi",
        id_father_menu: "demo_didattica",
        module_name: "didattica",
        item_name: "corsi",
        sort_order: "1",
        item_label: "Corsi",
        left_icon: null,
        route: "demo/didattica/corsi",
        enabled: "1",
        in_test: "1",
        childs: [],
      },
      {
        id_menu: "demo_didattica_materiale",
        id_father_menu: "demo_didattica",
        module_name: "didattica",
        item_name: "materiale_didattico",
        sort_order: "2",
        item_label: "Materiale didattico",
        left_icon: null,
        route: "demo/didattica/materiale-didattico",
        enabled: "1",
        in_test: "1",
        childs: [],
      },
    ],
  },
  {
    id_menu: "demo_documenti_utili",
    id_father_menu: "0",
    module_name: "documenti_utili",
    item_name: "documenti_utili",
    sort_order: "2",
    item_label: "Documenti utili",
    left_icon: "ri-folder-open-line",
    route: "demo/documenti-utili",
    enabled: "1",
    in_test: "1",
    childs: [],
  },
];

export const useMenu = () => {
  const accessToken = TokenStorage.getAccessToken();

  const { data: menuData, isLoading } = useQuery({
    queryKey: [MENU_QUERY_KEY],
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<MenuResponse>>("/menu/");
      return response.data.data.menu;
    },
    enabled: !!accessToken,
    staleTime: Infinity,
  });

  return {
    menuItems: menuData || [],
    isLoading,
  };
};
